<template>
  <div class="content">
    <div class="page-inner">
      <div class="mb-3" v-if="!user && !user._id">
        <div>
          <router-link to="/" class="mb-4">
            <i class="fa fa-chevron-left mr-1"></i> {{ $t('back') }}
          </router-link>
        </div>
        <div class="text-center mt-2">
          <router-link to="/">
            <img src="/static/img/logo_dark_new.png" width="150">
          </router-link>
        </div>
      </div>
      <div class="text-center mb-2">
        <h1 class="fw-light">{{ $t('upgrade_to_pro') }} 🚀</h1>
      </div>
      <div class="text-center pro-description mt-3 mb-2" v-html="$t('indiefy_pro_benefits')">
      </div>
      <LatestPro hidebuttons="1" class="mt-3"></LatestPro>
      <div class="plans mt-3">

        <div class="mb-4 text-center" v-if="!isMobile">
          <div class="text-center h3 fw-200" v-if="subscriptionType === 'monthly'" v-html="$t('monthly_plan')">
          </div>
          <div class="text-center h3 fw-200" v-if="subscriptionType === 'yearly'" v-html="$t('you_save_year')">
          </div>
          <div>
            <div @click="togglePeriod()" class="display-inline">
              <input type="checkbox" ref="period" data-toggle="toggle" data-onstyle="primary" data-style="btn-round" checked class="toggle-checkbox" data-size="small">
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4" v-if="!locationSettings.hide_basic">
            <div class="card" @click="plan = 'basic'" :class="{ selected: plan === 'basic' }">
              <div class="card-header clearfix">
                <div class="pull-left text-uppercase">
                  {{ $t('free_plan') }}
                </div>
              </div>
              <div class="card-body p-0">
                <ul class="list-group">
                  <li class="list-group-item text-muted">{{ $t('basic_royalties_percentage') }}</li>
                  <li class="list-group-item text-muted">{{ $t('one_artist_only') }}</li>
                  <li class="list-group-item text-muted">{{ $t('one_release_month') }}</li>
                  <li class="list-group-item text-muted">{{ $t('minimum_payment_free') }}</li>
                  <!-- <li class="list-group-item text-muted"><i class="fa fa-exclamation-triangle text-warning mr-2"></i> {{ $t('requires_verification') }}</li> -->
                </ul>
                <div class="p-2">
                  <button type="button" class="btn btn-light btn-block" :disabled="plan === 'basic'">
                    <span v-if="plan === 'basic'">
                      <span v-if="user._id && !user.subscription">
                        {{ $t('current') }}
                      </span>
                      <span v-else>
                        {{ $t('selected') }}
                      </span>
                    </span>
                    <span v-if="plan !== 'basic'">
                      {{ $t('select') }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4" v-if="locationSettings.hide_basic">
            <div class="card" @click="plan = 'lite'" :class="{ selected: plan === 'lite' }">
              <div class="card-header">
                <div class="pull-left text-primary">
                  LITE PLAN
                </div>
                <div class="pull-right fw-bold">
                  $14.99/<span>{{ $t('year') }}</span>
                </div>
              </div>
              <div class="card-body p-0">
                <ul class="list-group">
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> {{ $t('lite_artists') }}</li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> {{ $t('lite_releases') }}</li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> {{ $t('basic_analytics') }}</li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('no_ads') }} 🚫</span></li>
                </ul>
                <div class="p-2">
                  <button type="button" class="btn btn-block" @click="redirectToCheckout('lite')" :disabled="user.subscription && user.subscription.plan_name === 'indiefy_lite'">
                    <span v-if="!user._id || (user.subscription && user.subscription.plan_name !== 'indiefy_lite') || (user._id && !user.subscription)">
                      {{ $t('upgrade_now') }}
                    </span>
                    <span v-if="user.subscription && user.subscription.plan_name === 'indiefy_lite'">
                      {{ $t('current_plan') }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3 text-center" v-if="isMobile">
              <div class="text-center h3 fw-200" v-if="subscriptionType === 'monthly'" v-html="$t('monthly_plan')">
              </div>
              <div class="text-center h3 fw-200" v-if="subscriptionType === 'yearly'" v-html="$t('you_save_year')">
              </div>
              <div>
                <div @click="togglePeriod()" class="display-inline">
                  <input type="checkbox" ref="period" data-toggle="toggle" data-onstyle="primary" data-style="btn-round" checked class="toggle-checkbox" data-size="small">
                </div>
              </div>
            </div>

            <div class="card" @click="selectPlan('PRO')" :class="{ selected: plan === 'PRO' }">
              <div class="card-header">
                <div class="pull-left text-primary fw-bold">
                  INDIEFY PRO
                </div>
                <div class="pull-right">
                  <div class="text-right fw-bold">${{ proCost }} USD/{{ $t('month') }}</div>
                  <div class="text-right text-muted">
                    <span v-if="subscriptionType === 'yearly'">
                      {{ $t('billed_yearly') }}
                    </span>
                    <span v-if="subscriptionType === 'monthly'">
                      {{ $t('billed_monthly') }}
                    </span>
                  </div>
                </div>
                <span class="badge bg-danger badge-best text-white animated bounceIn text-uppercase">
                  {{ $t('most_popular') }} <i class="fa fa-fire ml-1 text-warning"></i>
                </span>
              </div>
              <div class="card-body p-0">
                <ul class="list-group">
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('no_ads') }} 🚫</span></li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('pro_royalties_percentage') }} *</span></li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('multiple_projects_artists') }}</span></li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('custom_label_name') }}</span></li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('social_accounts_verification') }} <i class="fab text-danger ml-1"></i> <i class="fab fa-youtube text-danger ml-1"></i> <i class="fab fa-spotify text-success ml-1 mr-1"></i> *</span></li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('premium_stores') }} <i class="fa fa-dollar-sign ml-1 text-warning"></i></span></li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('copyright_protection') }} (Content ID)</span></li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('minimum_payment_pro') }}</span></li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span>{{ $t('advanced_ai_tools') }}</span></li>
                  <li class="list-group-item text-right">
                    <a href="javascript:void(0)" class="btn-block text-right" @click="showAll = !showAll">
                      {{ $t('view_all_benefits') }} <i :class="{ 'fa-chevron-up': showAll, 'fa-chevron-down': !showAll }" class="fa ml-1 mt-1"></i>
                    </a>
                  </li>
                  <li v-show="showAll" class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i>TikTok, Instagram, Apple, {{ $t('and_more_ads') }}</li>
                  <li v-show="showAll" class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i>{{ $t('pro_releases_month') }}</li>
                  <li v-show="showAll" class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i>{{ $t('faster_payments') }}</li>
                  <li v-show="showAll" class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i>{{ $t('faster_release_dates') }}</li>
                  <!-- <li v-show="showAll" class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> {{ $t('pro_releases_month') }}</li> -->
                  <li v-show="showAll" class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> {{ $t('dedicated_support') }}</li>
                  <li v-show="showAll" class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> {{ $t('unlock_all_features') }}</li>
                  <li v-show="showAll" class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> {{ $t('presave_campaigns') }}</li>
                </ul>
                <div class="p-2" ref="upgradeButton">
                  <button type="button" class="btn btn-primary btn-block" @click="redirectToCheckout('pro')">
                    {{ $t('upgrade_now') }} <i class="fas fa-rocket ml-1"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- <div :class="{ 'col-md-3': !this.locationSettings.hide_basic, 'col-md-4': this.locationSettings.hide_basic }">
            <div class="card" @click="plan = 'Annual'" :class="{ selected: plan === 'Annual' }">
              <div class="card-header clearfix pos-relative">
                <div class="pull-left fw-bold text-uppercase">
                  <i class="fa fa-star mr-1 text-warning"></i> <span class="text-primary">{{ $t('annual_plan') }}</span>
                </div>
                <div class="pull-right fw-bold">
                  ${{ annualPlan }}/<span>{{ $t('year') }}</span>
                </div>
                <span class="badge bg-danger badge-best text-white animated bounceIn text-uppercase">
                  {{ $t('most_popular') }} <i class="fa fa-fire ml-1 text-warning"></i>
                </span>
              </div>
              <div class="card-body p-0">
                <ul class="list-group text-dark">
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> {{ $t('all_pro_features') }} + </li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span class="fw-bold">{{ $t('save_58') }}</span></li>
                  <li class="list-group-item"><i class="fa fa-check-circle text-success mr-2"></i> <span class="fw-bold">{{ $t('one_unique_yearly') }}</span></li>
                </ul>
                <div class="p-2">
                  <button type="button" class="btn btn-block btn-primary" @click="redirectToCheckout('annual')">
                    {{ $t('upgrade_now') }}
                  </button>
                </div>
              </div>
            </div>
          </div> -->

          <div class="col-md-4">
            <div class="card" @click="plan = 'Labels'" :class="{ selected: plan === 'Labels' }">
              <div class="card-header clearfix">
                <div class="pull-left text-primary">
                  Enterprise
                </div>
                <div class="pull-right fw-bold">
                  ${{ labelsCost }} USD/<span>{{ $t('year') }}</span>
                </div>
              </div>
              <div class="card-body p-0">
                <ul class="list-group">
                  <li class="list-group-item">{{ $t('all_pro_features') }}</li>
                  <li class="list-group-item">{{ $t('labels_artists_bands') }}</li>
                  <li class="list-group-item">{{ $t('labels_releases_month') }}</li>
                  <li class="list-group-item">{{ $t('personalised_customer_support') }}</li>
                </ul>
                <div class="p-2">
                  <button type="button" class="btn btn-block" :disabled="plan === 'Labels'">
                    <span v-if="plan === 'Labels'">
                      {{ $t('selected') }}
                    </span>
                    <span v-if="plan !== 'Labels'">
                      {{ $t('select') }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="text-center mt-3" ref="paymentButtons" v-if="plan === 'Labels'">
        <div v-if="plan !== 'basic'">
          <span class="h3">{{ $t('selected_plan') }} <b class="text-primary">{{ plan }}</b></span><br/>
          <span v-if="subscriptionType === 'yearly'">{{ $t('yearly_payment') }}</span><span v-if="subscriptionType === 'monthly'">{{ $t('monthly_payment') }}</span> <b v-if="plan === 'PRO'">${{ proCost }} USD</b><b v-if="plan === 'Labels'">${{ labelsCost }} USD</b>
        </div>
        <div class="mt-3">
          <p>
            {{ $t('please_contact_support_labels') }}<br/>
            <a href="mailto:support@indiefy.net">support@indiefy.net</a>
          </p>
          <button :disabled="redirecting" type="button" class="btn btn-gradient btn-lg" @click="redirectToCheckout('annual')" v-if="plan !== 'Labels'">
            <span v-if="!redirecting">{{ $t('upgrade_now') }}</span>
            <i v-if="redirecting" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>
      </div>
      <div class="mb-4 py-4">
        <div class="py-3"></div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import Configuration from '../services/configuration'
import Public from '../services/public'
import User from '../services/user'
import LatestPro from '../components/LatestPro'
import Artists from '../services/artists'

export default {
  name: 'Upgrade',
  data: function () {
    return {
      isMobile: false,
      showAll: false,
      subscriptionType: 'yearly',
      totalArtists: 0,
      artists: [],
      loginUrl: '/login?next=/upgrade',
      redirecting: false,
      user: {},
      moment: moment,
      plan: '',
      stripe: null,
      locationSettings: {
        hide_basic: false
      },
      lang: 'en',
      annualPlan: 49.99,
      labelsCost: 199.99
    }
  },
  computed: {
    proCost: function () {
      if (this.subscriptionType === 'monthly') {
        return 9.99
      } else {
        return 4.16
      }
    }
  },
  methods: {
    selectPlan: function (plan) {
      this.plan = plan

      if (this.plan === 'PRO') {
        let upgradeButton = this.$refs.upgradeButton
        upgradeButton.scrollIntoView()
      }
    },
    getLocationSettings: function () {
      this.subscriptionType = 'yearly'

      Public.getLocationSettings().then(response => {
        this.locationSettings = response.data

        if (this.$route.query.hide_basic) {
          this.locationSettings.hide_basic = true
        }
      })
    },
    togglePeriod: function () {
      if (this.subscriptionType === 'monthly') {
        this.subscriptionType = 'yearly'
      } else {
        this.subscriptionType = 'monthly'
      }

      this.plan = 'PRO'
    },
    animateValue: function (start, end, duration) {
      let startTimestamp = null

      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp
        const progress = Math.min((timestamp - startTimestamp) / duration, 1)
        this.totalArtists = Math.floor(progress * (end - start) + start)

        if (progress < 1) {
          window.requestAnimationFrame(step)
        }
      }

      window.requestAnimationFrame(step)
    },
    getArtists: function () {
      Artists.getAll({ limit: 1 }).then(response => {
        this.artists = response.data
      }).catch((err) => {
        console.error('Getting artist: ' + JSON.stringify(err))
      })
    },
    checkout: function (plan) {
      this.stripe.redirectToCheckout({
        lineItems: [{ price: plan, quantity: 1 }],
        mode: 'subscription',
        customerEmail: this.user.email,
        successUrl: 'https://indiefy.net/v1/api/user/upgrading?session_id={CHECKOUT_SESSION_ID}',
        cancelUrl: 'https://indiefy.net/upgrade?cancelled=1'
      }).then(function (result) {
        if (result.error) {
          alert(result.error.message)
        }

        this.redirecting = false
      })
    },
    redirectToCheckout: function (selectedPlan) {
      let plan = ''

      if (this.subscriptionType === 'yearly') {
        if (selectedPlan === 'Labels') {
          plan = 'plan_GxucdZQjJLKPiZ' // Labels
        } else if (selectedPlan === 'pro') { // PRO
          plan = 'price_1LFOeXK9qKRAJ5zqfGt7fcx8'
        } else if (selectedPlan === 'annual') {
          plan = 'price_1LFOeXK9qKRAJ5zqfGt7fcx8'
        } else if (selectedPlan === 'lite') {
          plan = 'price_1QNe9KK9qKRAJ5zqMtT6N7bR' // Lite
        } else {
          plan = 'price_1LFOeXK9qKRAJ5zqfGt7fcx8'
        }
      } else { // Monthly
        if (selectedPlan === 'Labels') {
          plan = 'plan_GxucdZQjJLKPiZ' // Labels
        } else if (selectedPlan === 'pro') { // PRO
          plan = 'price_1HccB9K9qKRAJ5zqKJCo4gf0'
        } else if (selectedPlan === 'lite') {
          plan = 'price_1QNe9KK9qKRAJ5zqMtT6N7bR' // Lite
        } else {
          plan = 'price_1LFOeXK9qKRAJ5zqfGt7fcx8'
        }
      }

      let subscriptionData = {
        from: this.$route.query.from || ''
      }

      if (window.localStorage) {
        subscriptionData.utm_campaign = localStorage.getItem('utm_campaign') || this.$route.query.utm_campaign || ''
        subscriptionData.utm_source = localStorage.getItem('utm_source') || this.$route.query.utm_source || ''
        subscriptionData.utm_medium = localStorage.getItem('utm_medium') || this.$route.query.utm_medium || ''
      }

      this.redirecting = true

      window.smartlook && window.smartlook('track', 'Checkout', { type: 'Subscriptions' })
      window.gtag && window.gtag('event', 'conversion', {'send_to': 'AW-323371496/1fPACNGmjZ0YEOiDmZoB'})

      User.setSubscriptionTrackingData(subscriptionData).then(() => {
        this.checkout(plan)
      }).catch((err) => {
        console.error('Error when trying to store subscription tracking', err)
        this.checkout(plan)
      })
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  },
  created: function () {
    this.user = this.$user
    this.isMobile = window.innerWidth <= 767

    if (this.$route.query.artist_limit) {
      this.$notify({ message: this.$t('artist_limit_reached') }, 'warning', 'fa-exclamation')
    }

    if (this.$route.query.distro_limit) {
      Configuration.get({fields: ['rise_limit_distro']}).then(response => {
        this.$notify({ message: response.data.rise_limit_distro ? this.$t('distro_limit_reached_2') : this.$t('distro_limit_reached') }, 'warning', 'fa-exclamation')
      })
    }

    if (!this.user.subscription) {
      this.plan = 'basic'
    }

    if (this.$route.query.from) {
      this.loginUrl = `/login?next=/upgrade?from=${this.$route.query.from}`
    }

    this.getArtists()
    this.getLocationSettings()
  },
  mounted: function () {
    let stripeKey = 'pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm'

    if (window.location.href.match(/localhost|cms-development/)) {
      stripeKey = 'pk_test_WD9FBh5jNgV5uO1eFQBkLdAl000Ey6vyno'
    }

    this.stripe = window.Stripe(stripeKey)

    setTimeout(() => {
      window.$('.toggle-checkbox[data-toggle]').bootstrapToggle({
        on: this.$t('yearly'),
        off: this.$t('monthly'),
        width: 120
      })

      window.prerenderReady = true

      if (this.$i18n) {
        this.lang = this.$i18n.locale
      }

      if (this.$route.query.lang) {
        this.lang = this.$route.query.lang
      }

      if (this.lang === 'es') {
        moment.locale('es-es')
      } else {
        moment.locale('en')
      }

      window.$('html, body').animate({
        scrollTop: 0
      }, 500)
    }, 100)

    Public.getPublicInfo().then(response => {
      this.animateValue(parseInt(response.data.total_users * 0.99, 10), response.data.total_users, 3000)
    })
  },
  components: {
    LatestPro
  }
}
</script>
<style lang='scss' scoped>
.badge-best {
  position: absolute;
  top: -13px;
  right: -10px;
}

.plans .card-body {
  cursor: pointer;
  position: relative;

  .price {
    position: absolute;
    top: 15px;
    right: 15px;
  }
}

.plans .card-primary h2 {
  color: white !important;
}

.basic-card {
  .current-plan {
    text-align: center;
    width: 100%;
    position: absolute;
    left: 0;
    top: -15px;

    > span {
      font-size: 12px;
      padding: 8px 10px;
      background: #ffffff;
      border-radius: 6px;
      color: black;
    }
  }
}

.pro-card {
  border-top: 3px solid #5714ff;
  border-radius: 6px;

  .most-popular {
    text-align: center;
    width: 100%;
    position: absolute;
    left: 0;
    top: -15px;

    > span {
      font-size: 11px;
      padding: 8px 10px;
      background: #5714ff;
      border-radius: 6px;
      color: white;
    }
  }
}
.pro-description {
  font-size: 14px;
}

.card.selected {
  border-top: 3px solid blue;
}
</style>



// WEBPACK FOOTER //
// src/components/Plans.vue